<template>
  <GBox
    flex
    class="announcement-slide-wrapper"
  >
    <GBox>
      <GText variant="subtitle-01">
        {{ title }}
      </GText>
      <GBox :mt="30">
        <div v-html="content" />
      </GBox>
    </GBox>
    <GBox class="img-wrapper">
      <GImage
        :src="imageSrc"
        default-image="https://cdn.dsmcdn.com/seller-center/shared/common/1x1.png"
      />
    </GBox>
  </GBox>
</template>

<script>
import GBox from '@trendyol-js/grace/core/GBox';
import GText from '@trendyol-js/grace/core/GText';
import GImage from '@trendyol-js/grace/core/GImage';

export default {
  name: 'AnnouncementSlide',

  components: {
    GBox,
    GImage,
    GText,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
  },

  computed: {
    imageSrc () {
      return `https://cdn.dsmcdn.com/seller-center/account/images/${this.image}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.announcement-slide-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 30px 20px;

  ::v-deep b {
    font-weight: 500 !important;
  }

  @media only screen and (max-width:767px) {
    ::v-deep img {
      max-width: 200px !important;
    }
  }

  @media only screen and (max-width:425px) {
    flex-direction: column;

    .img-wrapper {
      margin-top: var(--spacing-20);
    }

    ::v-deep img {
      max-width: 250px;
    }
  }

  @media only screen and (max-width:1024px) {
    flex-direction: column;

    .img-wrapper {
      margin-top: var(--spacing-20);
    }

    ::v-deep img {
      max-width: 250px;
    }
  }
}
</style>
